import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#ff5a00',
  width = '100%',
  className = '',
  viewBox = '0 0 20.158 23.038',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="calendar-star"
      d="M6.74,16.6l-.355,2.083a1.254,1.254,0,0,0,.5,1.233,1.281,1.281,0,0,0,.738.243,1.241,1.241,0,0,0,.585-.148l1.867-.981,1.867.981a1.262,1.262,0,0,0,1.831-1.327L13.422,16.6l1.507-1.471a1.257,1.257,0,0,0-.7-2.146l-2.088-.306-.931-1.894a1.265,1.265,0,0,0-1.134-.706,1.246,1.246,0,0,0-1.125.7l-.931,1.894-2.088.306a1.257,1.257,0,0,0-.7,2.146L6.74,16.6Zm2.232-2.614,1.107-2.245,1.107,2.245,2.475.36L11.87,16.1l.423,2.466L10.079,17.4,7.865,18.57,8.288,16.1,6.5,14.354ZM18,2.88h-2.16V.36a.361.361,0,0,0-.36-.36h-.72a.361.361,0,0,0-.36.36V2.88H5.76V.36A.361.361,0,0,0,5.4,0H4.68a.361.361,0,0,0-.36.36V2.88H2.16A2.16,2.16,0,0,0,0,5.04V20.878a2.16,2.16,0,0,0,2.16,2.16H18a2.16,2.16,0,0,0,2.16-2.16V5.04A2.16,2.16,0,0,0,18,2.88Zm.72,18a.722.722,0,0,1-.72.72H2.16a.722.722,0,0,1-.72-.72V8.639H18.718Zm0-13.679H1.44V5.04a.722.722,0,0,1,.72-.72H18a.722.722,0,0,1,.72.72Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
